module.exports = "fonts/LYjNdG7kmE0gfaN9pQ.woff2";